export interface INavigationRoute {
  name: string
  displayName: string
  meta: { icon: string }
  children?: INavigationRoute[]
}

export const mainRoutes: INavigationRoute[] = [
  {
    name: 'dashboard',
    displayName: 'menu.dashboard',
    meta: { icon: 'vuestic-iconset-dashboard' },
  },
  {
    name: 'qr-code',
    displayName: 'Qr-code',
    meta: { icon: 'qr_code' },
  },
  {
    name: 'teams',
    displayName: 'menu.teams',
    meta: { icon: 'groups' },
  },
  {
    name: 'payouts',
    displayName: 'menu.payouts',
    meta: { icon: 'credit_card' },
  },
  {
    name: 'faq',
    displayName: 'menu.faq',
    meta: { icon: 'quiz' },
  },
]

/** Routes shown in breadcrumbs but not in the sidebar. */
export const breadcrumbRoutes: INavigationRoute[] = [
  {
    name: 'onboarding-slide',
    displayName: 'menu.onboarding',
    meta: { icon: 'school' },
  },
]

export const teamRoutes: INavigationRoute[] = [
  {
    name: 'team-dashboard',
    displayName: 'menu.team-dashboard',
    meta: { icon: 'vuestic-iconset-dashboard' },
  },
  {
    name: 'team-invite',
    displayName: 'menu.team-invite',
    meta: { icon: 'groups' },
  },
  {
    name: 'team-shifts',
    displayName: 'menu.team-shifts',
    meta: { icon: 'schedule' },
  },
  {
    name: 'team-qr',
    displayName: 'menu.team-qr',
    meta: { icon: 'qr_code' },
  },
  {
    name: 'team-profile',
    displayName: 'menu.team-profile',
    meta: { icon: 'settings' },
  },
]

export default {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: mainRoutes,
}
